import createSvgIcon from 'shared/utils/createSvgIcon';

export default createSvgIcon(
  <>
    <defs xmlns="http://www.w3.org/2000/svg">
      <clipPath id="person">
        <circle cx="14.5" cy="14.5" r="14.5" />
      </clipPath>
    </defs>
    <g xmlns="http://www.w3.org/2000/svg" transform="translate(-25 -7)">
      <circle cx="4.5" cy="4.5" r="4.5" transform="translate(35 14)" />
      <g transform="translate(25 7)" className="c-person">
        <circle cx="13.5" cy="13.5" r="13.5" transform="translate(1 18)" />
      </g>
    </g>
  </>,
  '0 0 29 29'
);
